import { defineMessages } from 'react-intl';

export default defineMessages({
    all: {
        id: 'twia.gateway.views.account-detail.All',
        defaultMessage: 'All',
    },
    issued: {
        id: 'twia.gateway.directives.JobSummary.Issued',
        defaultMessage: 'Issued',
    },
    notTaken: {
        id: 'twia.gateway.directives.JobSummary.Not Taken',
        defaultMessage: 'Not Taken',
    },
    errorLoadingDocument: {
        id: 'twia.gateway.views.quote-documents.Error loading documents',
        defaultMessage: 'Error loading documents',
    },
    modalError: {
        id: 'twia.gateway.views.modal.Error',
        defaultMessage: 'Error',
    },
    errorLoadingNotes: {
        id: 'twia.gateway.views.quote-notes.Error loading notes',
        defaultMessage: 'Error loading notes.',
    },
    noClaimsResult: {
        id: 'twia.gateway.directives.ClaimSummaryDirective.ClaimSummary.There are no claims',
        defaultMessage: 'There are no claims',
    },
    gatewayViewsModalErrorData: {
        id: 'twia.gateway.views.modal.Error.Data',
        defaultMessage:
            'An error occurred while attempting to retrieve information. Please contact your administrator.',
    },
    withdrawRenewalCtrlTransaction: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Withdraw renewal transaction.',
        defaultMessage: 'Withdraw renewal transaction.',
    },
    startedByMistake: {
        id: 'twia.gateway.controllers.renewal.RenewalDetailCtrl.Was this renewal started by mistake?',
        defaultMessage: 'Was this renewal started by mistake? {link}',
    },
    fileAClaim: {
        id: 'twia.gateway.directives.ClaimSummaryDirective.claim-summary.File a Claim',
        defaultMessage: 'File a Claim',
    },
    noteCreated: {
        id: 'twia.gateway.directives.activity-schedule.Done',
        defaultMessage: 'Note Created',
    },
    noteCreatedSuccessfully: {
        id: 'twia.gateway.directives.activity-schedule.Note created',
        defaultMessage: 'You have successfully created a note.',
    },
    inactive: {
        id: 'twia.gateway.contacts.common.components.Contacts.AccountContacts.Inactive',
        defaultMessage: 'Inactive',
    },
    newQuote: {
        id: 'twia.gateway.views.new-quote.Start New Quote',
        defaultMessage: 'Start New Quote',
    },  
    required: {
        id: 'twia.gateway.views.new-quote.This is a required field.',
        defaultMessage: 'This is a required field.',
    }
});
